<template id="iframe-modal">
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ title }}</ion-title>
        <ion-buttons class="modal-confirmation-buttons" slot="end">
          <ion-button
            class="close-button"
            @click="closeModal()" 
            fill="solid"
            shape="round"
            color="medium-light" >
            <ion-icon slot="icon-only" :icon="closeSharp" :alt="i18n.$t('default_interaction.close')"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content scroll-y="false">
      <iframe :src="href" :title="title" :class="(invertColors) ? 'invert' : undefined"></iframe>
    </ion-content>
  </ion-page>
</template>

<script>

import { IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonContent, IonIcon, modalController } from '@ionic/vue';
import { defineComponent } from 'vue';

import { closeSharp } from 'ionicons/icons';

import { useI18n } from "@/utils/i18n";

const IFrameModal = defineComponent({
  name: 'IFrameModal',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonContent, IonIcon },
  props: {
    'title': String,
    'href': String,
    'invertColors': {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const i18n = useI18n();

    const closeModal = function(){
      modalController.dismiss();
    }

    return { i18n, closeModal, closeSharp };
  }
});

export async function openIFrameModal(component, title, href){
  if (component != null && title != null && href != null) {
    const modal = await modalController
      .create({
        component,
        cssClass: 'iframe-modal',
        componentProps: {
          title,
          href
        },
      })
    modal.present();
    return modal.onWillDismiss();
  }
}

export default IFrameModal;
</script>

<style>
.iframe-modal {
  --min-height: 90%;
  --min-width: min(900px, 90vw);
}
</style>

<style scoped>
iframe {
    background: var(--anirec-color-blue-950);
    border: none;
    overflow: scroll;
    width: 100%;
    height: 100%;
}

.dark iframe.invert {
  filter: hue-rotate(160deg) invert() brightness(90%);
}
</style>